import React from 'react';
import { Outlet } from 'react-router-dom';
import HeaderMain from '../homepage/HeaderMain';
import FooterMain from '../homepage/FooterMain';

function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <HeaderMain />
      <main className="flex-grow">
        <Outlet />
      </main>
      <FooterMain />
    </div>
  );
}

export default Layout; 